import React, {useMemo, useState} from "react";
import {Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";
import ChartCard from "./ChartCard.jsx";
import useStatisticsData from "./useStatisticsData.js";
import {formatEuro, formatEuroCompact, formatMonthPeriod, GROUP_PALETTE} from "./format.js";

/** #3 Umsatzverlauf über die Zeit, Monat/Jahr umschaltbar - eine einzelne
 * Datenreihe, daher ohne Legende. */
export default function RevenueTrendChart({filters}) {
    const [granularity, setGranularity] = useState("month");
    const params = useMemo(() => ({...filters, granularity, by_group: 0}), [filters, granularity]);
    const {data, loading, error} = useStatisticsData("/statistics/time-series", params);
    const rows = data?.rows || [];

    return (
        <ChartCard
            title="Umsatzverlauf"
            help="Nettoumsatz je Monat bzw. Jahr im gewählten Zeitraum und Filter."
            loading={loading}
            error={error}
            empty={!loading && rows.length === 0}
            height={280}
            actions={
                <div className="btn-group btn-group-sm" role="group" aria-label="Granularität">
                    <button type="button" aria-pressed={granularity === "month"} className={`btn ${granularity === "month" ? "btn-primary" : "btn-outline-secondary"}`} onClick={() => setGranularity("month")}>Monat</button>
                    <button type="button" aria-pressed={granularity === "year"} className={`btn ${granularity === "year" ? "btn-primary" : "btn-outline-secondary"}`} onClick={() => setGranularity("year")}>Jahr</button>
                </div>
            }
        >
            <ResponsiveContainer width="100%" height={280}>
                <AreaChart data={rows} margin={{top: 8, right: 12, left: 0, bottom: 0}}>
                    <defs>
                        <linearGradient id="statistics-revenue-fill" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor={GROUP_PALETTE[0]} stopOpacity={0.35} />
                            <stop offset="95%" stopColor={GROUP_PALETTE[0]} stopOpacity={0.03} />
                        </linearGradient>
                    </defs>
                    <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="var(--bs-border-color, #dee2e6)" />
                    <XAxis dataKey="period" tickFormatter={formatMonthPeriod} tick={{fontSize: 12}} axisLine={false} tickLine={false} />
                    <YAxis tickFormatter={formatEuroCompact} tick={{fontSize: 12}} axisLine={false} tickLine={false} width={70} />
                    <Tooltip
                        formatter={(value) => [formatEuro(value), "Nettoumsatz"]}
                        labelFormatter={(label) => formatMonthPeriod(label)}
                    />
                    <Area
                        type="monotone"
                        dataKey="net_amount"
                        stroke={GROUP_PALETTE[0]}
                        strokeWidth={2}
                        fill="url(#statistics-revenue-fill)"
                        dot={{r: 4}}
                        activeDot={{r: 5}}
                    />
                </AreaChart>
            </ResponsiveContainer>
        </ChartCard>
    );
}
